
import GwButton from '~/patterns/atoms/button/button';
import GwSalesContact from '~/patterns/organisms/sales-contact/sales-contact';
import GwStatSlab from '~/patterns/atoms/stat-slab/stat-slab.vue';
import GwStarRating from '~/patterns/atoms/star-rating/star-rating.vue';
export default {
    components: {
        GwButton,
        GwSalesContact,
        GwStatSlab,
        GwStarRating
    },
    props: {
        entry: {
            type: Object,
            default: () => { return {}; }
        }
    },
    methods: {
        getBrochureLink(entry) {
            const path = '/form/brochure';
            const courseId = entry.course[0]?.id;
            // This MUST match the course ID field "name" attribute in the form. Which in turn MUST match exactly the contact property in Hubspot.
            const query = `?course_id=${courseId}`;

            return path + query;
        }
    }
};
